import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-staging-client-profile',
  templateUrl: './staging-client-profile.component.html',
  styleUrls: ['./staging-client-profile.component.scss'],
})
export class StagingClientProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() client_data: any;

  selected_tab: any = 'Existing Products';

  constructor() {}

  ngOnInit(): void {}
}
